// extracted by mini-css-extract-plugin
export default {"container":"button-items-module__container--hhx4Q","fullWidth":"button-items-module__fullWidth--koe2V"};